import { createActions } from 'redux-actions';
import {
  CHANGE_SCREEN_ORIENTATION,
  CHECK_BROWSER_ONLINE,
  CLEAR_USER_DATA,
  CREATE_ADDRESS_FAILED,
  CREATE_ADDRESS_SUCCESS,
  DELETE_ADDRESS_FAILED,
  DELETE_ADDRESS_SUCCESS,
  EDIT_ADDRESS_FAILED,
  EDIT_ADDRESS_SUCCESS,
  HIDE_PASSWORD_SUCCESS,
  POST_PROFILE_SETTINGS,
  POST_PROFILE_SETTINGS_FAILED,
  POST_PROFILE_SETTINGS_SUCCESS,
  REMOVE_BANNER,
  REMOVE_BANNER_FAILED,
  REMOVE_BANNER_SUCCESS,
  REMOVE_IMAGE,
  REMOVE_IMAGE_FAILED,
  REMOVE_IMAGE_SUCCESS,
  REQUEST_PERSONAL_INFO,
  REQUEST_PERSONAL_INFO_FAILED,
  REQUEST_PERSONAL_INFO_SUCCESS,
  REQUEST_USER,
  REQUEST_USER_FAILED,
  REQUEST_USER_IMAGE,
  REQUEST_USER_IMAGE_FAILED,
  REQUEST_USER_IMAGE_SUCCESS,
  REQUEST_USER_SUCCESS,
  SEND_PENDING_DATA,
  SET_BROWSER_ONLINE,
  SHOW_FOOTER_NAVBAR,
  TOGGLE_MOBILE_MENU,
  UPDATE_BANNER,
  UPDATE_BANNER_FAILED,
  UPDATE_BANNER_SUCCESS,
  UPDATE_IMAGE,
  UPDATE_IMAGE_FAILED,
  UPDATE_IMAGE_SUCCESS,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_FAILED,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_USER,
  UPDATE_USER_FAILED,
  UPDATE_USER_SUCCESS,
} from '../constants';

export const {
  showFooterNavbar,
  requestUser,
  requestUserSuccess,
  requestUserFailed,
  updateBanner,
  updateBannerSuccess,
  updateBannerFailed,
  updateUser,
  updateUserSuccess,
  updateUserFailed,
  updateImage,
  updateImageSuccess,
  updateImageFailed,
  removeBanner,
  removeBannerSuccess,
  removeBannerFailed,
  removeImage,
  removeImageSuccess,
  removeImageFailed,
  updatePassword,
  updatePasswordSuccess,
  updatePasswordFailed,
  requestPersonalInfo,
  requestPersonalInfoSuccess,
  requestPersonalInfoFailed,
  requestUserImage,
  requestUserImageSuccess,
  requestUserImageFailed,
  sendPendingData,
  setBrowserOnline,
  toggleMobileMenu,
  checkBrowserOnline,
  changeScreenOrientation,
  hidePasswordSuccess,
  clearUserData,
  createAddressFailed,
  createAddressSuccess,
  deleteAddressFailed,
  deleteAddressSuccess,
  editAddressFailed,
  editAddressSuccess,
  postProfileSettings,
  postProfileSettingsFailed,
  postProfileSettingsSuccess,
} = createActions(
  REQUEST_USER,
  REQUEST_USER_SUCCESS,
  REQUEST_USER_FAILED,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILED,
  UPDATE_IMAGE,
  UPDATE_IMAGE_SUCCESS,
  UPDATE_IMAGE_FAILED,
  REMOVE_BANNER,
  REMOVE_BANNER_FAILED,
  REMOVE_BANNER_SUCCESS,
  REMOVE_IMAGE,
  REMOVE_IMAGE_SUCCESS,
  REMOVE_IMAGE_FAILED,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAILED,
  REQUEST_PERSONAL_INFO,
  REQUEST_PERSONAL_INFO_SUCCESS,
  REQUEST_PERSONAL_INFO_FAILED,
  REQUEST_USER_IMAGE,
  REQUEST_USER_IMAGE_SUCCESS,
  REQUEST_USER_IMAGE_FAILED,
  SEND_PENDING_DATA,
  SET_BROWSER_ONLINE,
  SHOW_FOOTER_NAVBAR,
  TOGGLE_MOBILE_MENU,
  CHECK_BROWSER_ONLINE,
  CHANGE_SCREEN_ORIENTATION,
  HIDE_PASSWORD_SUCCESS,
  CLEAR_USER_DATA,
  CREATE_ADDRESS_FAILED,
  CREATE_ADDRESS_SUCCESS,
  DELETE_ADDRESS_FAILED,
  DELETE_ADDRESS_SUCCESS,
  EDIT_ADDRESS_FAILED,
  EDIT_ADDRESS_SUCCESS,
  POST_PROFILE_SETTINGS,
  POST_PROFILE_SETTINGS_FAILED,
  POST_PROFILE_SETTINGS_SUCCESS,
  UPDATE_BANNER,
  UPDATE_BANNER_SUCCESS,
  UPDATE_BANNER_FAILED
);
